import { jsx as _jsx } from "react/jsx-runtime";
import { BrowserRouter as Router } from "react-router-dom";
import React, { memo } from "react";
import QuizRoutes from "./quizRoutes";
import store from "Root/profile/redux/store";
import { Provider } from "react-redux";
import "./main.scss";
const QuizApp = () => (_jsx(Router, { children: _jsx(Provider, { store: store, children: _jsx(QuizRoutes, {}) }) }));
export default memo(QuizApp);
